import { khattabaConversationParsing } from "../../../helpers/et3-conversation-parse";
import { TTextArea } from "../../../TypesNEW";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

const Et3TextArea = withLiteObserverAndTheme<TTextArea>((props) => {
  const {
    width,
    height,
    containerStyle,
    textFieldStyle,
    rowsNumber,
    placeHolder,
    message,
    onChange,
    theme
  } = props;
  const { unitX, unitY } = theme;
  const textFieldStyleFinalized = {
    width: width * unitX,
    height: height * unitY,
    border: 0,
    padding: 10 * unitX,
    ...textFieldStyle
  };
  const containerStyleFinalized = { overflow: "hidden", ...containerStyle };

  return (
    <ET3Div
      width={width}
      height={height}
      alignItems={"center"}
      justifyContent={"center"}
      fDirection={"row"}
      style={containerStyleFinalized}
      color={""}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <textarea
        style={textFieldStyleFinalized}
        rows={rowsNumber}
        placeholder={placeHolder}
        onChange={({ target }) => {
          const parsedText = khattabaConversationParsing(target.value);
          onChange(parsedText);
        }}
      >
        {message}
      </textarea>
    </ET3Div>
  );
});

export default Et3TextArea;
